module.exports = __webpack_public_path__ + "images/xibao_top_backview_2026-2027.1790731042052.jpg";